import { DeviceType } from './types'

interface DeviceProps {
  device: DeviceType
}

export default function Device({ device }: DeviceProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Name:</strong>
        {device.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {device.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Model:</strong>
        {device.model?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Community:</strong>
        {device.community_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Identifier:</strong>
        {device.identifier?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Status:</strong>
        {device.status?.toString()}
      </p>
    </div>
  )
}
